import { combineReducers } from 'redux';
import newsEdit from './news_edit';
import newsList from './news_list';
import videoTutorials from './video_tutorials';

export default combineReducers({
    newsEdit,
    newsList,
    videoTutorials,
});